<script lang="ts" setup>
  import { z } from 'zod'

  const internalIconSchema = z.enum([
    'add',
    'arrow-left',
    'arrow-right',
    'arrow-up-right',
    'calendar_icon',
    'category_icon',
    'checkmark',
    'chevron-down',
    'close',
    'delete',
    'dots-horizontal',
    'edit',
    'fire',
    'left_arrow_icon',
    'open_icon',
    'play-button',
    'related-stories',
    'search',
    'settings',
    'settings_icon',
    'shopping-bag',
    'travel',
    'trending-arrow',
    'trending-video',
    'trending-slider-left-arrow',
    'trending-slider-right-arrow',
    'tv',
    'video',
    'menu',
    'games-icon',
  ])

  type InternalIcons = z.infer<typeof internalIconSchema>
  const props = defineProps<{
    icon: InternalIcons | string
    classes?: string | string[]
  }>()

  const config = useRuntimeConfig()

  const isInternalIcon = computed(
    () => internalIconSchema.safeParse(props.icon).success
  )
</script>
<template>
  <img
    v-if="isInternalIcon"
    :src="`${config.app.cdnURL}/icons/${icon}.svg`"
    :alt="`icon ${icon}`"
    class="dark:filter dark:invert"
    :class="props.classes"
  />
  <UIcon v-if="!isInternalIcon" :name="icon" />
</template>
